import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EditStepForm from '../../../booking/components/bag_transport/EditStepForm';
import { bindActionCreators } from 'redux';
import { cancel, updateServiceItem, removeServiceItem, toggleEditServiceItem } from '../../../../data/booking/actions/booking';
import { normalizeStep } from '../../../../data/booking/normalizers/bag_transport';
import { getEditingService, getEditingItem, getPreviousEditingItem, getNextEditingItem } from '../../../../data/booking/selectors/booking';
import { getEditValues } from '../../../../data/booking/selectors/bag_transport_form';

class EditStepFormContainer extends Component {
    static propTypes = {
        initialValues: PropTypes.object,
        service: PropTypes.object,
        item: PropTypes.object,
        previousItem: PropTypes.object,
        nextItem: PropTypes.object,
        updateServiceItem: PropTypes.func,
        cancel: PropTypes.func,
        removeServiceItem: PropTypes.func
    };

    handleSubmit(values) {
        let normalizeValues = normalizeStep(values)

        return this.props.updateServiceItem(this.props.item.id, normalizeStep(values))
            .then(()=> {
                if(values.updatePreviousItem){
                    this.props.toggleEditServiceItem(this.props.service.id, this.props.previousItem.id)
                    return this.props.updateServiceItem(this.props.previousItem.id, {
                        ...normalizeStep(this.props.previousItem),
                        to: normalizeValues.from,
                        toStep: normalizeValues.fromStep,
                        arrivalLodgingNotFound: normalizeValues.departureLodgingNotFound,
                        arrivalLodgingInformation: normalizeValues.departureLodgingInformation
                    })
                }
                return true
            })
            .then(()=> {
                if(values.updateNextItem){
                    this.props.toggleEditServiceItem(this.props.service.id, this.props.nextItem.id)
                    return this.props.updateServiceItem(this.props.nextItem.id, {
                        ...normalizeStep(this.props.nextItem),
                        from: normalizeValues.to,
                        fromStep: normalizeValues.toStep,
                        departureLodgingNotFound: normalizeValues.arrivalLodgingNotFound,
                        departureLodgingInformation: normalizeValues.arrivalLodgingInformation
                    })
                }
                return true
            })
            .then(() => this.props.cancel());
    }

    handleClickBack(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.cancel();
    }

    handleRemove() {
        const { service, item } = this.props;

        this.props.removeServiceItem(service.id, item.id);
    }

    render() {
        const { service, initialValues, previousItem, nextItem } = this.props;

        return (
            <EditStepForm
                route={service.route}
                service={service}
                initialValues={initialValues}
                enableReinitialize={true}
                previousItem={previousItem}
                nextItem={nextItem}
                handleSubmit={::this.handleSubmit}
                onClickBack={::this.handleClickBack}
                onRemove={::this.handleRemove}
            />
        );
    }
}

export default connect(
    state => {
        let previousItem = getPreviousEditingItem(state.booking)
        if(previousItem){
            previousItem = {
                id: previousItem.id,
                ...getEditValues(state.booking, previousItem)
            }
        }

        let nextItem = getNextEditingItem(state.booking)
        if(nextItem){
            nextItem = {
                id: nextItem.id,
                ...getEditValues(state.booking, nextItem)
            }
        }

        return {
            service: getEditingService(state.booking),
            item: getEditingItem(state.booking),
            previousItem,
            nextItem,
            initialValues: getEditValues(state.booking)
        }
    },
    dispatch => bindActionCreators({ cancel, updateServiceItem, removeServiceItem, toggleEditServiceItem }, dispatch)
)(EditStepFormContainer);
